import { CharField, ImageField, SingleSelectField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { FileField } from "../../components/FileField"
import { WysiwygField } from "../../components/WysiwygField"
import type { Media } from "../../types"

export default function MediaForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Media>()

  const MEDIA_TYPE_OPTIONS = [
    { label: "Immagine", value: "IMAGE" },
    { label: "Documento", value: "DOC" },
  ]

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <SingleSelectField
        label="Tipo di media"
        layout="horizontal"
        options={MEDIA_TYPE_OPTIONS}
        value={MEDIA_TYPE_OPTIONS.find((option) => option.value === values.media_type) || null}
        placeholder="Seleziona un tipo di media"
        onChange={(value) => {
          setFieldValue("media_type", value?.value || "")
        }}
        isValid={submitCount > 0 ? !getIn(errors, "media_type") : undefined}
        errorMessage={getIn(errors, "media_type")}
      />
      {values.media_type === "IMAGE" && (
        <ImageField
          label="Immagine"
          layout="horizontal"
          value={values.media_file}
          required
          onChange={(value) => {
            setFieldValue("media_file", value)
          }}
          isValid={submitCount > 0 ? !getIn(errors, "media_file") : undefined}
          errorMessage={getIn(errors, "media_file")}
        />
      )}
      {values.media_type === "DOC" && (
        <FileField
          label="Documento"
          layout="horizontal"
          required
          value={values.media_file}
          onChange={(value) => {
            setFieldValue("media_file", value)
          }}
          isValid={submitCount > 0 ? !getIn(errors, "media_file") : undefined}
          errorMessage={getIn(errors, "media_file")}
        />
      )}
      <CharField
        label="Titolo"
        layout="horizontal"
        value={values.title || ""}
        onChange={(value) => {
          setFieldValue("title", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "title") : undefined}
        errorMessage={getIn(errors, "title")}
      />
      <WysiwygField
        label="Sorgente"
        layout="horizontal"
        value={values.source || ""}
        onChange={(value) => {
          setFieldValue("source", value)
        }}
      />
    </Col>
  )
}
